import React from "react";
import homeImg from "../../../../Assets/Images/newHome.png";
import HeaderPreview from "../../../GeneratePdf/HeaderPreview";
import FooterPreview from "../../../GeneratePdf/FooterPreview";

const styles = {
  pageWrapper: {
    margin: '0 auto',
    position: 'relative',
    overflow: 'hidden'
  },
  page: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    boxSizing: "border-box",
  },
  infoarea: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    flex: 1
  },
  coverImage: {
    maxWidth: "468px",
    height: "300px",
    objectFit: "cover",
  },
  numberContainer: {
    marginTop: "80px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  numberCircle: {
    width: "56px",
    height: "56px",
    border: "4px solid #00577D",
    borderRadius: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  numberText: {
    fontSize: "34px",
    fontWeight: "700",
    lineHeight: "30px",
    color: "#00577D",
    fontFamily: "Helvetica, sans-serif",
  },
  title: {
    fontFamily: "Helvetica, sans-serif",
    fontWeight: 700,
    fontStyle: "Bold",
    fontSize: "18px",
    lineHeight: "24px",
    letterSpacing: "0px",
    textAlign: "center",
    textTransform: "uppercase",
    color: "#00577D",
    marginTop: "16px",
  },
  subtitle: {
    fontFamily: "Helvetica , sans-serif",
    fontWeight: 700,
    fontStyle: "Bold",
    fontSize: "14px",
    lineHeight: "18px",
    letterSpacing: "0px",
    textAlign: "center",
    color: "#C99212",
  },
  footer: {
    width: "540px",
    borderTop: "1px solid #00577D",
    paddingTop: "5px",
    display: "flex",
    justifyContent: "space-between",
    position: "absolute",
    bottom: "20px",
    left: "20px",
    right: "20px",
  },
  footersection: {
    display: "flex",
    flexDirection: "column",
    maxWidth: "400px",
  },
  footerTextheading: {
    fontSize: "10px",
    fontWeight: "700",
    color: "#76A3BE",
    fontFamily: "Helvetica, sans-serif",
  },
  footerText: {
    fontSize: "8px",
    fontWeight: "400",
    color: "#76A3BE",
    fontFamily: "Helvetica, sans-serif",
  },
};

const HomeStarterQuadrantPreview = ({ apiData, pageNumber, reportType }) => {
  return (
    <>
      <HeaderPreview apiData={apiData} />
      <div style={{ backgroundColor: "rgb(255, 255, 255)", paddingTop: "16px" }}>
        <div style={styles.pageWrapper}>
          <div style={styles.page}>
            <div style={styles.infoarea}>
              <img src={homeImg} alt="Home" style={styles.coverImage} />
              <div style={styles.numberContainer}>
                <div style={styles.numberCircle}>
                  <span style={styles.numberText}>1</span>
                </div>
                <div style={styles.title}>HOME</div>
                <div style={styles.subtitle }>YOUR STARTER QUADRANT</div>
              </div>
            </div>
          </div>
        </div>
        <FooterPreview reportType={reportType} pageNumber={pageNumber} />
      </div>
    </>

  );
};

export default HomeStarterQuadrantPreview;
